import React from "react";
import Button from "../../common/button/button";
import DateFormat from "../../common/dateFormat/DateFormat";
import ButtonTable from "../../common/table/buttonTable";

export function LogManutencaoSolarTabela({ evento, usuarioLogado, itemSelecionado }) {
    return (
        <div className="custom-scroll" style={{ maxHeight: 400, overflowY: "auto" }}>
            <div>
                <Button
                    title={"Adicionar"}
                    style={{
                        width: 120,
                        height: 30,
                        padding: 0,
                        marginBlock: 10,
                    }}
                    text={"Adicionar"}
                    type={"success"}
                    disabled={!usuarioLogado.acesso_manutencao_solar_adicionar}
                    event={() => evento({ acao: "ADICIONAR", item: { id_unidade_consumidora: itemSelecionado.id_unidade_consumidora } })}
                />
            </div>
            <table style={{ borderCollapse: "collapse", minWidth: 700, width: "100%" }}>
                <thead>
                    <tr
                        style={{
                            position: "sticky",
                            zIndex: 1,
                            backgroundColor: "#586269",
                            color: "#FFF",
                            height: 40,
                            top: 0,
                        }}
                    >
                        <th style={{ paddingInline: 50 }}>Tipo de Manutenção</th>
                        <th style={{ textAlign: "center" }}>Data</th>
                        <th style={{ textAlign: "center" }}>Situação</th>
                        <th style={{ textAlign: "center" }}>Observação</th>
                        <th style={{ textAlign: "center" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {(itemSelecionado.manutencoes || []).map((log) => (
                        <tr key={log.id} style={{ borderBlock: "1px solid #464646", paddingTop: 30 }}>
                            <td style={{ paddingInline: 50 }}>{log.nome_tipo}</td>
                            <td style={{ textAlign: "center" }}>{DateFormat.formatarDataSqlParaTela(log.datahora)}</td>
                            <td style={{ textAlign: "center", backgroundColor: log.status ? "#57ff92" : "#82e6ff" }}>{log.status ? "Concluída" : "Em andamento"}</td>
                            <td style={{ textAlign: "center" }}>{log.observacao}</td>
                            <td width={140} style={{ verticalAlign: "top", textAlign: "right" }}>
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Visualizar"
                                    type={"primary"}
                                    icon={"fas fa-eye"}
                                    disabled={!usuarioLogado.acesso_manutencao_solar_visualizar}
                                    visible={true}
                                    event={() => evento({ acao: "VISUALIZAR", item: { ...log } })}
                                />
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Editar"
                                    type={"warning"}
                                    icon={"fas fa-pencil-alt"}
                                    disabled={!usuarioLogado.acesso_manutencao_solar_editar}
                                    visible={true}
                                    event={() => evento({ acao: "EDITAR", item: { ...log } })}
                                />
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Excluir"
                                    type={"danger"}
                                    icon={"fas fa-trash-alt"}
                                    disabled={!usuarioLogado.acesso_manutencao_solar_excluir}
                                    visible={true}
                                    event={() => evento({ acao: "EXCLUIR", item: { ...log } })}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
